import React from "react";
import NavigationMenu from "../Components/NavigationMenu/NavigationMenu";
import Header from "./Header";
import useMenuStore from "../store/menu/useMenuStore";
import { Outlet } from "react-router-dom";
import { NavigationBar } from "../Data/Navigation";
interface PageLayoutProps {
  children?: React.ReactNode;
}
export default function PageLayout(props: PageLayoutProps) {
  const { children } = props;
  const {items,loading} =useMenuStore();
  return (
    <div className="test">
    <Header />
    <div className="container-fluid pt-5 mt-5">
      <div className="d-flex">
        <div className="col-auto me-3">
        <NavigationMenu navItems={items} />
        </div>
        <div className="col ms-2 d-flex flex-column min-h-85">
    <Outlet/>
        </div>
        <div className="clearfix"></div>
      </div>
    </div>
  </div>

  );
}
